import deviceManager from "./DeviceManager";

export const getDeviceIdentifier = (): string => deviceManager.getKey();
